import { useAuthRestApi } from '../common';
import { Observable } from 'rxjs';
import { IMetricsApi, IMetricsReport, IVivliAdminSummary } from '@vivli/features/dashboard/infrastructure/interface';

export const useMetricsApi = (): IMetricsApi => {
    const { handleGet } = useAuthRestApi();
    const getMetricsReport = (queryString: string, orgId: string): Observable<IMetricsReport> => {
        return handleGet<IMetricsReport>(`/metricsReport/${orgId}?${queryString}`);
    };

    const getAggregateMetricsReport = (queryString: string): Observable<IMetricsReport> => {
        return handleGet<IMetricsReport>(`/metricsReport?${queryString}`);
    };

    const getAdminSummary = (queryString: string): Observable<IVivliAdminSummary> => {
        return handleGet<IVivliAdminSummary>(`/metricsReport/summary?${queryString}`);
    };

    return {
        getMetricsReport,
        getAggregateMetricsReport,
        getAdminSummary
    };
};
